import { Heart, Landmark, HandCoins } from "lucide-react";
import { DataTable, MetricCard, SectionHeading, ngn, usd } from "./ui";

const Breakdown = ({ title, rows, testId }) => (
  <div>
    <p className="text-[11px] uppercase tracking-wider text-foreground/55 font-medium mb-3">{title}</p>
    <DataTable testId={testId} headers={["Name", "Donations", "Gross ₦", "Platform ₦", "Gross $", "Platform $"]} empty={rows.length === 0 ? "No donations yet · ₦0.00 · $0.00" : null}>
      {rows.map((r) => (
        <tr key={r.id} className="hover:bg-white/[0.02]">
          <td className="p-3 font-medium max-w-[220px] truncate">{r.name}</td>
          <td className="p-3 tabular-nums">{r.count}</td>
          <td className="p-3 tabular-nums">{ngn(r.gross_naira)}</td>
          <td className="p-3 tabular-nums text-gold">{ngn(r.platform_naira)}</td>
          <td className="p-3 tabular-nums">{usd(r.gross_usd_cents)}</td>
          <td className="p-3 tabular-nums text-gold">{usd(r.platform_usd_cents)}</td>
        </tr>
      ))}
    </DataTable>
  </div>
);

export default function DonationsOverview({ data }) {
  const d = data || {};
  return (
    <section data-testid="donations-overview">
      <SectionHeading eyebrow="Support" title="Donations overview" description="Fan tips across the platform in ₦ (Paystack) and $ (Flutterwave). Filmmakers keep 70%, Cinevoya keeps 30%." />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        <MetricCard label="Donations received" value={(d.count || 0).toLocaleString()} hint={`${d.count_ngn || 0} in ₦ · ${d.count_usd || 0} in $`} icon={Heart} testId="don-count" />
        <MetricCard label="Gross donated · ₦" value={ngn(d.gross_naira)} icon={HandCoins} testId="don-gross" />
        <MetricCard label="Gross donated · $" value={usd(d.gross_usd_cents)} icon={HandCoins} testId="don-gross-usd" />
        <MetricCard accent label="Platform 30% · ₦" value={ngn(d.platform_naira)} icon={Landmark} tone="text-gold" testId="don-platform" />
        <MetricCard accent label="Platform 30% · $" value={usd(d.platform_usd_cents)} icon={Landmark} tone="text-gold" testId="don-platform-usd" />
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
        <Breakdown title="By film" rows={d.by_film || []} testId="don-by-film" />
        <Breakdown title="By filmmaker" rows={d.by_filmmaker || []} testId="don-by-filmmaker" />
      </div>
    </section>
  );
}
